import { ApiService } from "Services/ApiService";
import {
  ResultsDTO,
  SectionAdminDTO,
  SectionAdminRequestDTO
} from "Types";



export const sectionApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllSections: builder.query<SectionAdminDTO[], void>({
      query: () => ({
        url: "/admin/sections",
        method: "GET",
      }),
      transformResponse: (response: ResultsDTO<SectionAdminDTO[]>) => response.results ?? [],
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ name }) => ({
                type: "Section" as const,
                id: name,
              })),
              { type: "Section", id: "LIST" },
            ]
          : [{ type: "Section", id: "LIST" }],
    }),

    getSectionById: builder.query<SectionAdminDTO, number>({
      query: (id) => ({
        url: `/admin/sections/${id}`,
        method: "GET",
      }),
      transformResponse: (response: ResultsDTO<SectionAdminDTO>) => response.results,
      providesTags: (result, error, id) => [{ type: "Section", id }],
    }),

    createSection: builder.mutation<ResultsDTO<number>, SectionAdminRequestDTO>({
      query: (data) => ({
        url: "/admin/sections/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "Section", id: "LIST" }],
    }),

    updateSection: builder.mutation<ResultsDTO<number>, { id: number; data: SectionAdminRequestDTO }>({
      query: ({ id, data }) => ({
        url: `/admin/sections/update/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Section", id }],
    }),

    deleteSection: builder.mutation<ResultsDTO<number>, number>({
      query: (id) => ({
        url: `/admin/sections/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Section", id }],
    }),

    uploadSectionImages: builder.mutation<ResultsDTO, { id: number; images: File[] }>({
      query: ({ id, images }) => {
        const formData = new FormData();
        images.forEach((image) => {
          formData.append("images", image);
        });
        return {
          url: `/admin/sections/upload/${id}`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: (result, error, { id }) => [{ type: "Section", id }],
    }),
  }),
});

export const {
  useGetAllSectionsQuery,
  useGetSectionByIdQuery,
  useCreateSectionMutation,
  useUpdateSectionMutation,
  useDeleteSectionMutation,
  useUploadSectionImagesMutation,
} = sectionApiSlice;
